import React from "react";
import { StyleSheet, Pressable } from "react-native";

//Custom Imports
import color from "@constants/color";
import t from "@constants/localization";
import RightArrow from "@assets/svg/RightArrow";
import CustomText from "@components/CustomText";
import { CONTEST_EVENTS } from "@constants/analyticsEventsCT";

const PATH = "screens/Contest/contestDetails";

const OrdersPlacedCard = ({ item = {}, navigation, trackEvent = () => {} }) => {
  const { ordered_cx = 0, contest_id = "", total_cx = "" } = item || {};

  const orderedCard = () => {
    trackEvent(CONTEST_EVENTS.ORDERS_PLACED_CLICKED, {
      screen: "Contest Details",
      total_customer_with_order: ordered_cx,
      total_customer_count: total_cx,
    });
    navigation.navigate("OrderedList", { contest_id, orderedCx: ordered_cx });
  };

  return (
    <Pressable onPress={orderedCard} style={styles.container}>
      <CustomText
        variant="subtitle_16"
        newfont={true}
        numberOfLines={1}
        style={styles.ordersPlaced}
      >
        {`${t(`${PATH}/ordersPlaced`)}: `}
        <CustomText
          variant="title_18"
          newfont={true}
          numberOfLines={1}
          style={styles.countText}
        >
          {ordered_cx}
        </CustomText>
      </CustomText>
      <RightArrow
        fill={color.lightMediumBlack}
        stroke={color.lightMediumBlack}
      />
    </Pressable>
  );
};

export default OrdersPlacedCard;

const styles = StyleSheet.create({
  container: {
    marginTop: 24,
    elevation: 8,
    shadowColor: color.mediumBlack,
    shadowOffset: { width: 2, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 4.65,
    borderRadius: 10,
    backgroundColor: color.white,
    padding: 16,
    marginHorizontal: 16,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  ordersPlaced: {
    color: color.lightBlack,
    textTransform: "capitalize",
  },
  countText: {
    color: color.mediumBlack,
  },
});
